import { CalendarManager } from '@benzinga/calendar-manager';
import { OptionsActivity } from '@benzinga/calendar-option-activity-manager';
import { CommonCalendarQueryParams } from '@benzinga/calendar-commons';
import { Session } from '@benzinga/session';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchOptions = (
  session: Session,
  params: CommonCalendarQueryParams,
  pageSize = 100,
): Promise<OptionsActivity[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('optionsActivity', { ...params, pageSize })
    .then(res => (res.ok ? (res.ok as OptionsActivity[]).filter(item => Number(item.cost_basis) > 500000) : []))
    .catch(error => {
      logCalendarFetchFailure('unusual-options-activity', error);
      return [];
    });
};

export { fetchOptions };
